import React, { useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { FaCalendarAlt } from "react-icons/fa";
import "./MobileCategoryFilterPopup.css";

const MobileCategoryFilterPopup = ({
  onClose,
  columnSearch,
  setColumnSearch,
  handleRefresh,
  onAdd,
}) => {
  const [startDate, setStartDate] = useState(columnSearch.startDate || null);
  const [endDate, setEndDate] = useState(columnSearch.endDate || null);
  const [status, setStatus] = useState(columnSearch.status || "Active");

  const handleStatusChange = (e) => {
    const value = e.target.value;
    setStatus(value);
    setColumnSearch({
      ...columnSearch,
      status: value,
    });
  };

  return (
    <div className="product-filter-popup-overlay" onClick={onClose}>
      <div className="product-filter-popup" onClick={(e) => e.stopPropagation()}>
        <h3>Filters</h3>


        <div className="mobile-product-filter-group">
          <label>Status</label>
          <select
            className="mobile-product-select"
            value={status}
            onChange={handleStatusChange}
          >
            <option value="Active">Active</option>
            <option value="Deactive">Deactive</option>
          </select>
        </div>

    
        <div className="product-date-row" style={{ marginTop: "10px" }}>
          <div className="mobile-product-filter-group">
            <label>Start Date</label>
            <div className="product-date-wrapper">
              <DatePicker
                selected={startDate}
                onChange={(date) => {
                  setStartDate(date);
                  setColumnSearch({
                    ...columnSearch,
                    startDate: date,
                  });
                }}
                placeholderText="Start Date"
                dateFormat="dd/MM/yyyy"
                className="product-mobile-date-picker"
              />
              <FaCalendarAlt className="calendar-icon" />
            </div>
          </div>

          <div className="mobile-product-filter-group">
            <label>End Date</label>
            <div className="product-date-wrapper">
              <DatePicker
                selected={endDate}
                onChange={(date) => {
                  setEndDate(date);
                  setColumnSearch({
                    ...columnSearch,
                    endDate: date,
                  });
                }}
                placeholderText="End Date"
                dateFormat="dd/MM/yyyy"
                className="product-mobile-date-picker"
              />
              <FaCalendarAlt className="calendar-icon" />
            </div>
          </div>
        </div>

        <button className="product-filter-close-btn" onClick={onClose}>
          Close
        </button>
      </div>
    </div>
  );
};

export default MobileCategoryFilterPopup;